import React from 'react';
import ReactDOM from 'react-dom';
import { ReactComponent as Close } from '../../assets/icons/close.svg';
import { getDisplayFileName } from '../../assets/utils/utils';
import { resolveMediaUrl } from '../../assets/utils/mediaUrl';
import classes from '../../styles/components/modals/uploadModal.module.scss';

const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp'];
const AUDIO_EXTENSIONS = ['mp3', 'mpeg', 'wav', 'ogg', 'webm', 'm4a', 'mp4', 'aac'];

/** مودال پیش‌نمایش فایل از URL (فایل‌های آپلود شده روی سرور) */
/** isNested: وقتی true باشد، مودال روی مودال دیگری باز شده - رندر در backdrop-root با z-index بالاتر */
const RemoteFilePreviewModal = ({ file, onClose, isNested }) => {
    if (!file?.path) return null;

    const url = resolveMediaUrl(typeof file.path === 'string' ? file.path : file.path?.path || '');
    const displayName = getDisplayFileName(file);
    const ext = displayName?.split('.').pop()?.toLowerCase() || '';
    const isImage = IMAGE_EXTENSIONS.includes(ext);
    const isPdf = ext === 'pdf';
    const isAudio = AUDIO_EXTENSIONS.includes(ext);

    const modalContent = (
        <div
            className={classes.answerModal}
            onClick={(e) => e.stopPropagation()}
            style={{
                maxWidth: '90vw',
                maxHeight: '90vh',
                display: 'flex',
                flexDirection: 'column',
                ...(isNested ? { zIndex: 10002 } : {}),
            }}
        >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                <span style={{ fontSize: 13, color: '#464646' }}>{displayName}</span>
                <button
                    type="button"
                    onClick={onClose}
                    style={{
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        padding: 4,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                    title="بستن"
                >
                    <Close width={24} height={24} style={{ color: '#888' }} />
                </button>
            </div>
            <div style={{ flex: 1, overflow: 'auto', display: 'flex', justifyContent: 'center', alignItems: 'flex-start', minHeight: 300 }}>
                {isImage && (
                    <img src={url} alt={displayName} style={{ maxWidth: '100%', maxHeight: '70vh', objectFit: 'contain' }} referrerPolicy="no-referrer" />
                )}
                {isPdf && (
                    <iframe
                        src={url}
                        title={displayName}
                        style={{ width: '100%', minHeight: 500, border: 'none' }}
                    />
                )}
                {isAudio && (
                    <audio controls src={url} style={{ width: '100%' }}>
                        مرورگر شما از پخش صدا پشتیبانی نمی‌کند.
                    </audio>
                )}
                {!isImage && !isPdf && !isAudio && (
                    <p style={{ color: '#888', padding: 20 }}>پیش‌نمایش برای این فرمت پشتیبانی نمی‌شود. <a href={url} target="_blank" rel="noopener noreferrer">دانلود فایل</a></p>
                )}
            </div>
        </div>
    );

    const backdrop = (
        <div
            className={classes.modalBackDrop}
            onClick={onClose}
            style={isNested ? { zIndex: 10001 } : {}}
        />
    );

    if (isNested) {
        return (
            <>
                {ReactDOM.createPortal(backdrop, document.getElementById('backdrop-root'))}
                {ReactDOM.createPortal(modalContent, document.getElementById('backdrop-root'))}
            </>
        );
    }

    return (
        <>
            {ReactDOM.createPortal(backdrop, document.getElementById('backdrop-root'))}
            {ReactDOM.createPortal(modalContent, document.getElementById('overlayUploadModal-root'))}
        </>
    );
};

export default RemoteFilePreviewModal;
